import { React, useState } from "react";
import { DatePicker, Row, Col, Select, Button } from "antd";
import { moment } from "@LIBS";
import { Constants } from "@CONFIG";
const { Option } = Select;

const Filters = ({ onChange }) => {
  const [openEndDate, setOpenEndDate] = useState(false);
  const [openStartDate, setOpenStartDate] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const setFilters = () => {
    if (startDate && endDate) {
      const startDateFormatted = startDate.format(
        Constants.FORMATS.systemDateFormat
      );
      const endDateFormatted = moment(endDate)
        .add(1, "days")
        .format(Constants.FORMATS.systemDateFormat);
      onChange({
        startDate: startDateFormatted,
        endDate: endDateFormatted,
      });
    }
  };
  return (
    <Row gutter={24}>
      <Col span={4}>
        <DatePicker
          placeholder="Başlangıç tarihi"
          format={Constants.FORMATS.dateFormat}
          style={{ width: "100%" }}
          disabledDate={(current) => {
            return (
              current.isBefore(moment().add(-90, "days")) ||
              current.isBefore(moment(endDate)?.add(-30, "days")) ||
              current.isAfter(moment()) ||
              current.isAfter(moment(endDate))
            );
          }}
          ranges={{
            Bugün: [moment(), moment()],
          }}
          open={openStartDate}
          onOpenChange={setOpenStartDate}
          value={startDate}
          onChange={(val) => {
            setStartDate(val);
            if (!endDate) {
              setEndDate(val);
              setOpenEndDate(true);
            }
          }}
        />
      </Col>
      <Col span={4}>
        <DatePicker
          placeholder="Bitiş tarihi"
          format={Constants.FORMATS.dateFormat}
          style={{ width: "100%" }}
          disabledDate={(current) => {
            return (
              current.isBefore(moment().add(-90, "days")) ||
              current.isBefore(moment(startDate)) ||
              current.isAfter(moment()) ||
              current.isAfter(moment(startDate)?.add(30, "days"))
            );
          }}
          ranges={{
            Bugün: [moment(), moment()],
          }}
          open={openEndDate}
          onOpenChange={(e) => setOpenEndDate(e)}
          value={endDate}
          onChange={(val) => {
            if (!startDate) {
              setStartDate(val);
              setOpenStartDate(true);
            }

            setEndDate(val);
          }}
        />
      </Col>
      <div style={{ width: 120 }}>
        <Button
          type="primary"
          block
          disabled={!startDate || !endDate}
          onClick={setFilters}
        >
          Rapor Sorgula
        </Button>
      </div>
    </Row>
  );
};

export default Filters;
